/* import __COLOCATED_TEMPLATE__ from './latest-conversations.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();